/*global $:false */
"use strict";

/**
 * CAROUSEL
 */
$(document).ready(function() {
    var $carousel = $('#carousel'),
        $carousel_nav = $('#carousel-nav'),
        carousel_instance = null;

    //  Build Carousel
    function buildCarousel() {
        $carousel.removeClass('mobile');

        //  Init owlCarousel
        carousel_instance = $carousel.owlCarousel({
            items: 1,
            loop: true,
            nav: false,
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
            autoplay: true,
            autoplayTimeout: 3000,
            animateOut: 'fadeOut',
            dotsContainer: $carousel_nav,
        });

        //  Handle hover navigation
        var $porfolio_nav = $('#portfolio-nav');
        $porfolio_nav.find('a').each(function (idx, elt) {
            $(elt).mouseover(function (evt) {
                carousel_instance.trigger('to.owl.carousel', [idx]);
                carousel_instance.trigger('stop.owl.autoplay')
            });
            $(elt).mouseout(function (evt) {
                carousel_instance.trigger('play.owl.autoplay')
            });
        });

        // Handle keys navigation
        $(document.documentElement).keyup(function (event) {
            if (event.keyCode == 37) {
                carousel_instance.trigger('prev.owl.carousel');
            } else if (event.keyCode == 39) {
                carousel_instance.trigger('next.owl.carousel');
            }
        });
    }

    //  Destroy Carousel
    function destroyCarousel() {
        if (carousel_instance !== null) {
            carousel_instance.trigger('destroy.owl.carousel');
            carousel_instance = null;
        }
        $carousel.addClass('mobile');
    }

    $(window)
        .resize(function (evt) {
            if ($(window).width() > 768) {
                buildCarousel();
            } else {
                destroyCarousel();
            }
        })
        .trigger('resize');
});
